export enum ExclusionEqualityType {
    EQUALS = 'EQUALS',
    NOT_EQUALS = 'NOT_EQUALS'
}

export const exclusionEqualityTypeDisplay = {
    [ExclusionEqualityType.EQUALS]: 'Equals',
    [ExclusionEqualityType.NOT_EQUALS]: 'Does not equal'
};
